var _style, _desc, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 40",
    style: {
      enableBackground: "new 0 0 60 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F3F6F9;}\n\t.st1{fill:#F48628;}\n\t.st2{fill:#001722;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "discover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 60,
    height: 40
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.4,16c-2.2,0-4.1,1.8-4.1,3.9c0,2.3,1.7,4,4.1,4c2.3,0,4.1-1.7,4.1-4C35.4,17.8,33.6,16,31.4,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.3,16.2H6.1v7.6h2.2c1.2,0,2-0.3,2.7-0.9c0.9-0.7,1.4-1.8,1.4-2.9C12.4,17.7,10.7,16.2,8.3,16.2z M10,21.9 c-0.5,0.4-1.1,0.6-2,0.6H7.6v-5H8c1,0,1.5,0.2,2,0.6c0.5,0.5,0.8,1.2,0.8,1.9C10.8,20.7,10.5,21.4,10,21.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16.2,
    className: "st2",
    width: 1.5,
    height: 7.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.2,19.1c-0.9-0.3-1.2-0.5-1.2-1c0-0.5,0.5-0.8,1.1-0.8c0.4,0,0.8,0.2,1.2,0.6l0.8-1 c-0.6-0.6-1.4-0.8-2.2-0.8c-1.3,0-2.4,0.9-2.4,2.2c0,1.1,0.5,1.6,1.9,2.1c0.6,0.2,0.9,0.3,1,0.4c0.3,0.2,0.4,0.5,0.4,0.8 c0,0.6-0.5,1.1-1.2,1.1c-0.7,0-1.3-0.4-1.6-1l-1,0.9c0.7,1,1.5,1.5,2.6,1.5c1.5,0,2.6-1,2.6-2.5C20.4,20.3,19.9,19.7,18.2,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.8,20c0,2.2,1.8,4,4,4c0.6,0,1.2-0.1,1.9-0.4v-1.8c-0.6,0.6-1.1,0.8-1.8,0.8c-1.5,0-2.6-1.1-2.6-2.6 c0-1.5,1.1-2.6,2.5-2.6c0.7,0,1.2,0.3,1.9,0.9v-1.8c-0.7-0.3-1.2-0.5-1.8-0.5C22.6,16,20.8,17.8,20.8,20z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "38.8,21.3 36.8,16.2 35.1,16.2 38.4,24 39.2,24 42.5,16.2 40.9,16.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "43.1,23.8 47.4,23.8 47.4,22.5 44.6,22.5 44.6,20.5 47.3,20.5 47.3,19.2 44.6,19.2 44.6,17.5 47.4,17.5 47.4,16.2 43.1,16.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.3,18.4c0-1.4-1-2.3-2.7-2.3h-2.2v7.6h1.5v-3.1H50l2.1,3.1h1.8l-2.4-3.2C52.6,20.4,53.3,19.6,53.3,18.4z  M50.3,19.7h-0.4v-2.3h0.5c0.9,0,1.4,0.4,1.4,1.1C51.7,19.3,51.2,19.7,50.3,19.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.df2ed3b9f00584f835e12f2bd2c87963.svg";
export { ForwardRef as ReactComponent };